import { jsx as d } from "react/jsx-runtime";
import { getCSSValue as h } from "../../utils/get-css-value.js";
import { getBorderRadius as a } from "../../utils/get-border-radius.js";
import { Background as m } from "../background/background.js";
import w from "clsx";
import { forwardRef as u } from "react";
import '../../assets/block.css';const g = "_block_90isf_26", o = {
  block: g,
  "block--overflow-hidden": "_block--overflow-hidden_90isf_37",
  "block--overflow-visible": "_block--overflow-visible_90isf_41",
  "block--overflow-scroll": "_block--overflow-scroll_90isf_45",
  "block--overflow-auto": "_block--overflow-auto_90isf_49",
  "block--width-auto": "_block--width-auto_90isf_53",
  "block--width-fit-content": "_block--width-fit-content_90isf_57",
  "block--width-min-content": "_block--width-min-content_90isf_61",
  "block--width-max-content": "_block--width-max-content_90isf_65",
  "block--width-inherit": "_block--width-inherit_90isf_69",
  "block--width-full-width": "_block--width-full-width_90isf_73",
  "block--height-auto": "_block--height-auto_90isf_77",
  "block--height-fit-content": "_block--height-fit-content_90isf_81",
  "block--height-min-content": "_block--height-min-content_90isf_85",
  "block--height-max-content": "_block--height-max-content_90isf_89",
  "block--height-inherit": "_block--height-inherit_90isf_93",
  "block--height-full-height": "_block--height-full-height_90isf_97"
}, S = u(
  ({
    className: b = "",
    children: k,
    padding: c,
    margin: e,
    overflow: l = "visible",
    bg: _,
    style: f,
    rounded: n,
    width: t = "auto",
    height: i = "auto",
    ...r
  }, s) => /* @__PURE__ */ d(
    m,
    {
      variant: _,
      className: w(
        o.block,
        {
          [o["block--overflow-hidden"]]: l === "hidden",
          [o["block--overflow-visible"]]: l === "visible",
          [o["block--overflow-scroll"]]: l === "scroll",
          [o["block--overflow-auto"]]: l === "auto",
          [o["block--width-auto"]]: t === "auto",
          [o["block--width-fit-content"]]: t === "fit-content",
          [o["block--width-full-width"]]: t === "full-width",
          [o["block--width-max-content"]]: t === "max-content",
          [o["block--width-min-content"]]: t === "min-content",
          [o["block--width-inherit"]]: t === "inherit",
          [o["block--height-auto"]]: i === "auto",
          [o["block--height-fit-content"]]: i === "fit-content",
          [o["block--height-full-height"]]: i === "full-height",
          [o["block--height-max-content"]]: i === "max-content",
          [o["block--height-min-content"]]: i === "min-content",
          [o["block--height-inherit"]]: i === "inherit"
        },
        b
      ),
      style: {
        "--padding": c ? h(c) : void 0,
        "--margin": e ? h(e) : void 0,
        "--border-radius": n ? a(n) : void 0,
        "--height": i ?? void 0,
        "--width": t ?? void 0,
        ...f
      },
      ...r,
      ref: s,
      children: k
    }
  )
);
export {
  S as Block
};
